import { render, staticRenderFns } from "./UpdateConfig.vue?vue&type=template&id=7e60a9fa"
import script from "./UpdateConfig.vue?vue&type=script&lang=js"
export * from "./UpdateConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports